import router from '@/router'
// import { createOrg } from '@/services'
import {
  inviteGetComInfo,
  inviteJoinFirst,
  inviteJoinLast,
  inviteInfoPerfect
} from '@/services/organization'
import rules from './rules'
export default {
  namespaced: true,
  state: {
    submitting: false,
    auth: '',
    // 全部的数据容器
    companyDatas: {},
    // datas数据是否准备就绪
    datasReady: false,
    invitecode: '',
    decorators: {
      mobile: ['mobile', { rules: rules.tel }],
      username: ['username', { rules: rules.username }],
      password: ['password', { rules: rules.password }],
      checkcode: ['checkcode', { rules: rules.validCode }]
    }
  },
  mutations: {
    setSubmitting (state, type) {
      state.submitting = type
    },
    setAuth (state, auth) {
      state.auth = auth
    },
    // 设置数据容器的值
    setCompanyDatas (state, datas) {
      state.companyDatas = datas
      state.datasReady = true
    },
    setInviteCode (state, code) {
      state.invitecode = code
    }
  },
  actions: {
    // 获取公司数据
    async fetchCompanyDatas ({ commit, state }) {
      // commit('setSubmitting', true)
      const chain = await inviteGetComInfo()
        .params({ invitecode: state.invitecode })
        .onNetSuccess((raw) => {
          let res = raw.data
          commit('setCompanyDatas', raw.data.payload)
          if (!res.error) {
            const company = res.payload
            if (state.auth) {
              router.push({ path: '/organization/invitejoinresult',
                query: {
                  invitecode: state.invitecode,
                  comname: company.comname,
                  inviteuser: company.inviteuser
                } })
            } else {
              router.push({ path: '/organization/invitejoin',
                query: {
                  invitecode: state.invitecode,
                  comname: company.comname
                } })
            }
          } else if (res.error === 100) {
            router.push({ name: 'OrgInviteJoinLose' })
          }
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 第一次加入
    async ajaxJoin ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await inviteJoinFirst()
        .onSuccess(async () => {
          // const res = await dispatch('fetchOrgDatas')
          // res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 完善资料 设置帐号
    async ajaxSave ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await inviteInfoPerfect()
        .onSuccess(async () => {
          // const res = await dispatch('fetchOrgDatas')
          // res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 第一次加入
    async ajaxLastJoin ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await inviteJoinLast()
        .onSuccess(async () => {
          // const res = await dispatch('fetchOrgDatas')
          // res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    }
  }
}
